module.exports = __webpack_public_path__ + "assets/img/cancel_btn.9134fec1.png";